// src/pages/CreateAccountPage.js
import React, { useContext, useRef, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../services/api";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { FaWhatsapp, FaEye, FaEyeSlash } from "react-icons/fa";
import { submitWholesaleRequest } from "../services/wholesaleRequests.api";

function CreateAccountPage() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [loginForm, setLoginForm] = useState({
  username: "",
  password: "",
});

  const [wholesaleForm, setWholesaleForm] = useState({
  fullName: "",
  phone: "",
  email: "",
  businessName: "",
  instagramName: "",
  instagramLink: "",
});

  const [uiError, setUiError] = useState("");
  const [uiSuccess, setUiSuccess] = useState("");
const messageRef = useRef(null);
  const [loading, setLoading] = useState(false);
const [loadingAction, setLoadingAction] = useState(null); // "login" | "register" | null
const [showLoginPassword, setShowLoginPassword] = useState(false);

  const TEXT = {
    EN: {
      mainPage: "Main page",
      authentication: "Authentication",
      title: "AUTHENTICATION",
      emailOptional: "Email (optional)",

      loginTitle: "Logging",
      loginIdentifier: "Username",
loginName: "Password",
      signIn: "SIGN IN »",

      or: "OR",

      createTitle: "Wholesale account request",
wholesaleIntro:
  "If you want to create an account to see our wholesale products and prices, contact us on WhatsApp or fill up this form.",
fullName: "Full name",
phone: "Phone number",
businessName: "Business name",
instagramName: "Business Instagram profile name",
instagramLink: "Instagram page link",
whatsapp: "CONTACT US ON WHATSAPP",
submitRequest: "SUBMIT REQUEST »",
successMessage: "Your wholesale request has been submitted successfully.",
duplicatePhone: "This phone number already submitted a wholesale request.",
fillWholesale: "Please enter full name, phone number, and business name.",
submittingRequest: "SUBMITTING...",

      signingIn: "SIGNING IN...",
registering: "REGISTERING...",
      fillLogin: "Please enter username and password.",
      fillRegister: "Please enter full name and phone number.",
      phoneInvalid: "Phone number is invalid.",
    },
    AR: {
      mainPage: "الصفحة الرئيسية",
      authentication: "تسجيل الدخول",
      title: "تسجيل الدخول",
signingIn: "جارٍ تسجيل الدخول...",
registering: "جارٍ إنشاء الحساب...",
      loginTitle: "تسجيل الدخول",
      loginIdentifier: "اسم المستخدم",
      loginName: "كلمة المرور",
      signIn: "تسجيل الدخول »",

      or: "أو",
      emailOptional: "البريد الإلكتروني (اختياري)",

      createTitle: "طلب حساب جملة",
wholesaleIntro:
  "إذا كنت تريد إنشاء حساب لمشاهدة منتجات وأسعار الجملة، تواصل معنا عبر واتساب أو املأ هذا النموذج.",
fullName: "الاسم الكامل",
phone: "رقم الهاتف",
businessName: "اسم العمل",
instagramName: "اسم حساب الإنستغرام الخاص بالعمل",
instagramLink: "رابط صفحة الإنستغرام",
whatsapp: "تواصل معنا عبر واتساب",
submitRequest: "إرسال الطلب »",
successMessage: "تم إرسال طلب حساب الجملة بنجاح.",
duplicatePhone: "رقم الهاتف هذا أرسل طلب حساب جملة من قبل.",
fillWholesale: "يرجى إدخال الاسم الكامل ورقم الهاتف واسم العمل.",
submittingRequest: "جارٍ الإرسال...",

      fillLogin: "يرجى إدخال اسم المستخدم وكلمة المرور.",
      fillRegister: "يرجى إدخال الاسم الكامل ورقم الهاتف.",
      phoneInvalid: "رقم الهاتف غير صحيح.",
    },
  }[lang];

  const formatLbLocal = (digits) => {
    const d = digits.slice(0, 8);
    const p1 = d.slice(0, 2);
    const p2 = d.slice(2, 5);
    const p3 = d.slice(5, 8);
    return [p1, p2, p3].filter(Boolean).join(" ");
  };

  const formatLbPlus961 = (digitsAfter961) => {
    const d = digitsAfter961.slice(0, 8);
    const p1 = d.slice(0, 2);
    const p2 = d.slice(2, 5);
    const p3 = d.slice(5, 8);
    const parts = [p1, p2, p3].filter(Boolean).join(" ");
    return parts ? `+961 ${parts}` : "+961";
  };

  const formatPhoneInput = (raw) => raw;

  const formatLoginIdentifierInput = (raw) => {
  const value = raw || "";

  // Keep emails untouched
  if (value.includes("@")) {
    return value;
  }

  // Keep text untouched until it clearly looks like a Lebanese phone
  const compact = value.replace(/\s/g, "");

  if (
    compact.startsWith("+961") ||
    compact.startsWith("961") ||
    compact.startsWith("0") ||
    compact.startsWith("7") ||
    compact.startsWith("8")
  ) {
    if (compact.startsWith("961") && !compact.startsWith("+961")) {
      return formatLbPlus961(compact.slice(3).replace(/\D/g, ""));
    }

    return formatPhoneInput(value);
  }

  return value;
};

    const validatePhone = () => true;

  const scrollToMessage = () => {
    setTimeout(() => {
      messageRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 100);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;
    setUiError("");
    setUiSuccess("");

    if (!loginForm.username.trim() || !loginForm.password.trim()) {
  setUiError(TEXT.fillLogin);
  return;
}

    try {
  setLoading(true);
  setLoadingAction("login");

      const res = await apiRequest("/auth/login", {
        method: "POST",
        body: JSON.stringify({
  username: loginForm.username,
  password: loginForm.password,
}),
      });

      localStorage.setItem("esill-token", res.token);

      await apiRequest("/analytics/track", {
        method: "POST",
        body: JSON.stringify({
          action_type: "login_sync",
        }),
      }).catch(() => {});

      window.dispatchEvent(new Event("auth-changed"));
navigate("/");
    } catch (err) {
      setUiError(err.message);
    } finally {
      setLoading(false);
setLoadingAction(null);
    }
  };

  const handleWholesaleRequest = async (e) => {
  e.preventDefault();
  if (loading) return;

  setUiError("");
  setUiSuccess("");

  if (
    !wholesaleForm.fullName.trim() ||
    !wholesaleForm.phone.trim() ||
    !wholesaleForm.businessName.trim()
  ) {
    setUiError(TEXT.fillWholesale);
scrollToMessage();
return;
  }

  if (!validatePhone(wholesaleForm.phone)) {
    setUiError(TEXT.phoneInvalid);
scrollToMessage();
return;
  }

  try {
    setLoading(true);
    setLoadingAction("wholesale");

    await submitWholesaleRequest(wholesaleForm);

    setUiSuccess(TEXT.successMessage);
scrollToMessage();

setWholesaleForm({
  fullName: "",
  phone: "",
  email: "",
  businessName: "",
  instagramName: "",
  instagramLink: "",
});
  } catch (err) {
    if (err.status === 409) {
  setUiError(TEXT.duplicatePhone);
} else {
  setUiError(err.message);
}

scrollToMessage();
  } finally {
    setLoading(false);
    setLoadingAction(null);
  }
};

  const inputClass = `
    w-full
    h-11
    border border-gray-400
    bg-white
    px-3
    text-sm
    outline-none
    focus:border-black
    transition
    disabled:bg-gray-100
    disabled:text-gray-500
    disabled:cursor-wait
  `;

  const labelClass = "block text-[12px] font-medium text-gray-900 mb-1";

  const outlineButtonClass = `
  w-full
  h-11
  rounded-md
  border border-black border-[2px]
  bg-white
  text-gray-900
  text-sm font-semibold tracking-wide
  hover:bg-black hover:text-white
  active:scale-[0.99]
  transition
  disabled:opacity-60
  disabled:cursor-wait
  disabled:hover:bg-white
  disabled:hover:text-gray-900
`;

const whatsappButtonClass = `
  w-full
  h-11
  rounded-md
  bg-[#25D366]
  text-white
  text-sm font-semibold tracking-wide
  flex items-center justify-center gap-2
  hover:opacity-90
  active:scale-[0.99]
  transition
`;

const whatsappLink = "https://wa.me/961XXXXXXXX";

  return (
    <div
  className="w-full min-h-screen bg-[#fff] overflow-x-hidden"
  dir={lang === "AR" ? "rtl" : "ltr"}
>
      <TopBanner />
      <MainHeader />

      <main className="bg-[#fff] px-4 md:px-8  md:pt-[170px]">
        {/* BREADCRUMB */}
        <div className="text-[12px] md:text-sm text-gray-900 mb-6">
          <button
  type="button"
  onClick={() => navigate("/")}
  className="hover:text-black hover:underline"
>
  {TEXT.mainPage}
</button>

          <span className="mx-2">›</span>

          <span className="text-gray-900">{TEXT.authentication}</span>
        </div>

        {/* TITLE */}
        <div className="text-left mb-2">
          <h1 className="text-[16px] md:text-[20px] font-normal tracking-wide text-gray-900 uppercase">
            {TEXT.title}
          </h1>
        </div>

        {/* THICK LINE */}
        <div className="h-[1px] bg-gray-300 mx-1 md:mx-4 mb-8" />

        {/* MESSAGE */}
{(uiError || uiSuccess) && (
  <div
    ref={messageRef}
    className={`
      max-w-5xl mx-auto mb-5
      border
      text-sm
      px-4 py-3
      rounded-md
      flex items-start gap-2
      ${
        uiSuccess
          ? "border-green-200 bg-green-50 text-green-700"
          : "border-red-200 bg-red-50 text-red-700"
      }
    `}
  >
    <span className="font-bold leading-5">
      {uiSuccess ? "✓" : "!"}
    </span>
    <span>{uiSuccess || uiError}</span>
  </div>
)}

        {/* CONTENT */}
        <div className="max-w-6xl mx-auto">
          {/* MOBILE */}
          <div className="md:hidden">
            {/* LOGIN */}
            <section className="pb-7">
              <h2 className="text-center text-[18px] font-normal text-gray-900 mb-6">
                {TEXT.loginTitle}
              </h2>

              <form onSubmit={handleLogin} className="space-y-4" autoComplete="off">
                <div>
                  <label className={labelClass}>{TEXT.loginIdentifier}</label>
                  <input
  disabled={loading}
   type="text"
  name="etika-login-username"
  autoComplete="new-password"
  className={inputClass}
  value={loginForm.username}
onChange={(e) =>
  setLoginForm((prev) => ({
    ...prev,
    username: e.target.value,
  }))
}
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.loginName}</label>
                  <div className="relative">
  <input
    disabled={loading}
    type={showLoginPassword ? "text" : "password"}
    name="etika-login-passcode"
    autoComplete="new-password"
    className={`${inputClass} pr-10 ${lang === "AR" ? "pr-3 pl-10" : ""}`}
    value={loginForm.password}
    onChange={(e) =>
      setLoginForm((prev) => ({
        ...prev,
        password: e.target.value,
      }))
    }
  />

  <button
    type="button"
    onClick={() => setShowLoginPassword((v) => !v)}
    className={`
      absolute top-1/2 -translate-y-1/2
      ${lang === "AR" ? "left-3" : "right-3"}
      text-gray-500 hover:text-black
    `}
  >
    {showLoginPassword ? <FaEyeSlash /> : <FaEye />}
  </button>
</div>
                </div>

                <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "login" ? TEXT.signingIn : TEXT.signIn}
</button>
              </form>
            </section>

            <div className="text-center font-bold text-gray-900 mb-7">
              {TEXT.or}
            </div>

            {/* WHOLESALE REQUEST */}
<section className="pb-7">
  <h2 className="text-center text-[18px] font-normal text-gray-900 mb-4">
    {TEXT.createTitle}
  </h2>

  <p className="text-center text-sm text-gray-700 leading-6 mb-5">
    {TEXT.wholesaleIntro}
  </p>

  <a
    href={whatsappLink}
    target="_blank"
    rel="noopener noreferrer"
    className={whatsappButtonClass}
  >
    <FaWhatsapp className="text-[18px]" />
    {TEXT.whatsapp}
  </a>

  <form onSubmit={handleWholesaleRequest} className="space-y-4 mt-5">
    <div>
      <label className={labelClass}>{TEXT.fullName}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.fullName}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            fullName: e.target.value,
          }))
        }
      />
    </div>

    <div>
      <label className={labelClass}>{TEXT.phone}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.phone}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
 phone: e.target.value,
          }))
        }
      />
    </div>
<div>
  <label className={labelClass}>{TEXT.emailOptional}</label>
  <input
    disabled={loading}
    type="email"
    className={inputClass}
    value={wholesaleForm.email}
    onChange={(e) =>
      setWholesaleForm((prev) => ({
        ...prev,
        email: e.target.value,
      }))
    }
  />
</div>
    <div>
      <label className={labelClass}>{TEXT.businessName}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.businessName}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            businessName: e.target.value,
          }))
        }
      />
    </div>

    <div>
      <label className={labelClass}>{TEXT.instagramName}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.instagramName}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            instagramName: e.target.value,
          }))
        }
      />
    </div>

    <div>
      <label className={labelClass}>{TEXT.instagramLink}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.instagramLink}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            instagramLink: e.target.value,
          }))
        }
      />
    </div>

    <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "wholesale" ? TEXT.submittingRequest : TEXT.submitRequest}
</button>
  </form>
</section>

          </div>

          {/* DESKTOP */}
          <div className="hidden md:grid grid-cols-[1fr_1px_1fr] gap-10 pb-12">
            {/* LOGIN COLUMN */}
            <section>
              <h2 className="text-center text-[20px] font-normal text-gray-900 mb-8">
                {TEXT.loginTitle}
              </h2>

              <form onSubmit={handleLogin} className="space-y-5 max-w-md mx-auto" autoComplete="off">
                <div>
                  <label className={labelClass}>{TEXT.loginIdentifier}</label>
                  <input
  disabled={loading}
   type="text"
  name="etika-login-username"
  autoComplete="new-password"
  className={inputClass}
  value={loginForm.username}
onChange={(e) =>
  setLoginForm((prev) => ({
    ...prev,
    username: e.target.value,
  }))
}
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.loginName}</label>
                 <div className="relative">
  <input
    disabled={loading}
    type={showLoginPassword ? "text" : "password"}
    name="etika-login-passcode"
    autoComplete="new-password"
    className={`${inputClass} pr-10 ${lang === "AR" ? "pr-3 pl-10" : ""}`}
    value={loginForm.password}
    onChange={(e) =>
      setLoginForm((prev) => ({
        ...prev,
        password: e.target.value,
      }))
    }
  />

  <button
    type="button"
    onClick={() => setShowLoginPassword((v) => !v)}
    className={`
      absolute top-1/2 -translate-y-1/2
      ${lang === "AR" ? "left-3" : "right-3"}
      text-gray-500 hover:text-black
    `}
  >
    {showLoginPassword ? <FaEyeSlash /> : <FaEye />}
  </button>
</div>
                </div>

                <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "login" ? TEXT.signingIn : TEXT.signIn}
</button>
              </form>
            </section>

            {/* VERTICAL LINE */}
            <div className="bg-gray-300 w-px min-h-[360px]" />

            {/* WHOLESALE REQUEST COLUMN */}
<section>
  <h2 className="text-center text-[20px] font-normal text-gray-900 mb-4">
    {TEXT.createTitle}
  </h2>

  <p className="max-w-md mx-auto text-center text-sm text-gray-700 leading-6 mb-5">
    {TEXT.wholesaleIntro}
  </p>

  <div className="max-w-md mx-auto mb-5">
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className={whatsappButtonClass}
    >
      <FaWhatsapp className="text-[18px]" />
      {TEXT.whatsapp}
    </a>
  </div>

  <form onSubmit={handleWholesaleRequest} className="space-y-5 max-w-md mx-auto">
    <div>
      <label className={labelClass}>{TEXT.fullName}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.fullName}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            fullName: e.target.value,
          }))
        }
      />
    </div>

    <div>
      <label className={labelClass}>{TEXT.phone}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.phone}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
 phone: e.target.value,
          }))
        }
      />
    </div>
<div>
  <label className={labelClass}>{TEXT.emailOptional}</label>
  <input
    disabled={loading}
    type="email"
    className={inputClass}
    value={wholesaleForm.email}
    onChange={(e) =>
      setWholesaleForm((prev) => ({
        ...prev,
        email: e.target.value,
      }))
    }
  />
</div>
    <div>
      <label className={labelClass}>{TEXT.businessName}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.businessName}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            businessName: e.target.value,
          }))
        }
      />
    </div>

    <div>
      <label className={labelClass}>{TEXT.instagramName}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.instagramName}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            instagramName: e.target.value,
          }))
        }
      />
    </div>

    <div>
      <label className={labelClass}>{TEXT.instagramLink}</label>
      <input
      disabled={loading}
        className={inputClass}
        value={wholesaleForm.instagramLink}
        onChange={(e) =>
          setWholesaleForm((prev) => ({
            ...prev,
            instagramLink: e.target.value,
          }))
        }
      />
    </div>

    <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "wholesale" ? TEXT.submittingRequest : TEXT.submitRequest}
</button>
  </form>
</section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default CreateAccountPage;
